import React from 'react';
import EditLead from '../components/EditLead';

function EditLeadPage() {
  return (
    <EditLead/>
  );
}

export default EditLeadPage;
